<div class="popup-container">
  <div class="popup-header">
    <h2>Configure Google Calendar</h2>
    <p class="subtitle">Set up your integration settings and authentication</p>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="instructions-box error">
    <p class="instructions-title">
      <mat-icon style="color: #310737;">error</mat-icon> Google Cloud Setup
    </p>
    <p class="instructions-text">
      Create OAuth 2.0 credentials in Google Cloud Console for Calendar and Gmail integration.
    </p>
    <a href="https://console.cloud.google.com/" target="_blank" class="doc-link">
      <mat-icon inline>launch</mat-icon> Google Cloud Console
    </a>
  </div>

  <form class="form-section" (ngSubmit)="save()" #form="ngForm" novalidate>
    <div class="form-field">
      <label>Client ID *</label>
      <input type="text" placeholder="Google OAuth Client ID" name="clientId" [(ngModel)]="formData.clientId" required>
    </div>

    <div class="form-field">
      <label>Client Secret *</label>
      <input type="text" placeholder="Google OAuth Client Secret" name="clientSecret" [(ngModel)]="formData.clientSecret" required>
    </div>

    <div class="form-field">
      <label>Redirect URI</label>
      <input type="text" placeholder="OAuth redirect URI" name="redirectUri" [(ngModel)]="formData.redirectUri">
    </div>

    <div class="dialog-footer">
<button  mat-stroked-button  type="button"  (click)="close()" class="cancel-button">
  Cancel
</button>

        <button mat-flat-button color="primary" [disabled]="form.invalid" type="submit" class="save-config-button">
  Save Configuration
</button>

    </div>
  </form>
</div>
